exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host{background-color:#7eaeda}img{max-width:100%;height:auto;display:block}p,h1{color:#fff}h1{margin-bottom:50px}", ""]);

// exports
